// src/Components/CrispChat/index.js

import { useEffect } from 'react';
import { Crisp } from 'crisp-sdk-web';
import './crispChat.css';

const CrispChat = () => {
  useEffect(() => {
    // Initialize Crisp with your website ID
    const websiteId = process.env.REACT_APP_CRISP_WEBSITE_ID || 'e6dd81e5-3455-4727-a68c-d05291978c30';

    Crisp.configure(websiteId);

    // Set higher z-index to appear above other buttons
    Crisp.chat.onChatOpened(() => {
      const crispChat = document.querySelector('#crisp-chatbox');
      if (crispChat) {
        crispChat.style.zIndex = '999999';
      }
    });

    // On mobile: re-hide launcher after user closes the chat
    Crisp.chat.onChatClosed(() => {
      if (window.innerWidth <= 900) {
        Crisp.chat.hide();
      }
    });

    // Optional: Set user data if available
    const userEmail = localStorage.getItem('userEmail');
    const userName = localStorage.getItem('userName');

    if (userEmail) {
      Crisp.user.setEmail(userEmail);
    }

    if (userName) {
      Crisp.user.setNickname(userName);
    }

    // Optional: Set custom data
    Crisp.session.setData({
      app: 'HappyChef Dashboard',
      version: '1.0',
      environment: process.env.NODE_ENV
    });

    // Apply z-index immediately after initialization
    setTimeout(() => {
      const crispElements = document.querySelectorAll('.crisp-client, #crisp-chatbox');
      crispElements.forEach(el => {
        el.style.zIndex = '999999';
      });
    }, 1000);

    // Hide Crisp launcher on mobile — retry multiple times since Crisp loads async
    const hideLauncherOnMobile = () => {
      if (window.innerWidth <= 900) {
        Crisp.chat.hide();
      }
    };

    // Crisp takes time to inject its DOM, so retry several times
    setTimeout(hideLauncherOnMobile, 1000);
    setTimeout(hideLauncherOnMobile, 2000);
    setTimeout(hideLauncherOnMobile, 3500);
    setTimeout(hideLauncherOnMobile, 5000);

    // Also handle resize (e.g. rotating phone)
    const handleResize = () => {
      if (window.innerWidth <= 900) {
        Crisp.chat.hide();
      } else {
        Crisp.chat.show();
      }
    };
    window.addEventListener('resize', handleResize);

    // Clean up on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // This component doesn't render anything
  return null;
};

export default CrispChat;
